export const LOCALES = {
  english: 'en-US',
  spanish: 'es-US',
}

export const DefaultLocale = LOCALES.english
